import state from "./state";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

/** Admin module. */
export const adminModule = {
    state,
    getters,
    mutations,
    actions,
};
